<template>
  <div class="columns">
    <section class="section column is-2 menu-background">
      <Menu />
    </section>
    <section class="column is-10">

      <div class="navbar-custom-pc">
        <NavBar />
      </div>


      <div>
        <div class="level">
          <div class="level-left">
            <div class="level-item">
              <span class="is-size-3 has-text-weight-bold">Family</span>
              <span style="margin-left:25px">
                <b-button type="is-primary" icon-pack="fas" icon-left="fas fa-plus" @click="newProduct">New Family
                </b-button>
              </span>
            </div>
          </div>
        </div>
        <b-table :data="isEmpty ? [] : family" :sort-icon="sortIcon" :sort-icon-size="sortIconSize" icon-pack="fas"
          default-sort="index" paginated per-page="10" hoverable :loading="loading" pagination-rounded backend-filtering
          @filters-change="(input)=>searchFamily(input)" :debounce-search=500 backend-pagination
          @page-change="(a)=>pageChange(a)" :total="total">
          <b-table-column label="#" numeric v-slot="props">{{ props.row.index }}</b-table-column>



          <b-table-column field="family_name" label="Family Name" v-slot="props" searchable>
            {{ props.row.family_name }}</b-table-column>

          <b-table-column label="Edit" v-slot="props">
            <span>
              <b-button icon-pack="fas" icon-left="fas fa-edit" type="is-info" inverted @click="editFamily(props.row)">
              </b-button>
            </span>
          </b-table-column>
          <b-table-column label="Delete" v-slot="props">
            <span>
              <b-button icon-pack="fas" icon-left="fas fa-trash-alt" type="is-danger" inverted
                @click="deleteFamily(props.row)"></b-button>
            </span>
          </b-table-column>
          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <img src="../assets/undraw_void_3ggu.svg" width="25%" />
                <p class="is-size-4 has-text-weight-semibold has-text-link">No Family</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
    </section>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Menu from '@/components/Menu.vue'
export default {
  name: 'Family',
  data() {
    return {
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      family: [],
      isEmpty: false,
      loading: false,
      initData: [],
      total: 3
    }
  },
  components: {
    NavBar,
    Menu
  },
  mounted() {
    this.loadFamilyInit()
  },
  methods: {
    loadFamilyInit() {
      this.loading = true
      this.$store.dispatch('getFamily')
        .then((response) => {
          this.family = []
          this.family.push(...response.result.family_data)
          if (this.family.length > 0) {
            this.family.forEach((item, index) => {
              this.family[index].index = ++index
            })
          }
          this.initData.push(...this.family)
        })
        .catch(() => {
          this.ToastError('Problem loading family')
        })
        .finally(() => {
          this.loading = false
        })
    },
    searchFamily(input) {
      if (input.family_name) {
        this.loading = true

        this.$store.dispatch('searchFamily', input.family_name)
          .then((response) => {
            this.family = []
            this.family.push(...response.result.family_data)
            if (this.family.length > 0) {
              this.family.forEach((item, index) => {
                this.family[index].index = ++index
              })
            }
          })
          .catch(() => {
            this.ToastError('Problem loading products')
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.product = []
        this.product.push(...this.initData)
      }

    },
    pageChange(a) {
      console.log(a)
    },
    newProduct() {
      this.$router.push({
        name: "NewFamily"
      })
    },
    editFamily(data) {
      this.$router.push({
        name: "UpdateFamily",
        params: data
      })
    },
    deleteFamily(data) {
      this.$buefy.dialog.confirm({
        title: 'Delete Family',
        message: 'Are you sure you want to delete this family?',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$store.dispatch('deleteFamily', data)
            .then((response) => {
              if (response.error == 0) {
                this.ToastSuccess("Family deleted")
                this.loadFamilyInit()
              } else {
                this.ToastError("Problem deleting family")
              }
            })
            .catch(() => {
              this.ToastError("Problem deleting family")
            })
        }
      })
    }
  }

}
</script>

<style>
/* .menu-background{
    background-color: #26547C;
} */
</style>